module.exports = __webpack_public_path__ + "img/3m.fe45802a.png";